<template>
    <div
        v-if="!isCreditOffer && !isEmptyValue(offer.monthly_repayment_display)"
        class="column-container d-flex order-lg-4 order-1 me-lg-auto"
    >
        <OfferMonthlyRepayment />
    </div>

    <div class="column-container d-flex order-lg-2 order-2 me-lg-auto">
        <OfferAmount :largeMobileValue="false" />
    </div>

    <div class="column-container d-flex order-lg-3 order-3 me-lg-auto">
        <OfferRates />
    </div>

    <div v-if="isCreditOffer" class="column-container d-flex order-lg-5 order-4 me-lg-auto">
        <OfferFees />
    </div>

    <div
        v-if="offer?.term_display !== '0' && isCreditOffer"
        class="column-container d-flex order-lg-4 order-3 me-lg-auto"
    >
        <OfferTermCredit />
    </div>
</template>

<script>
export default {
    inject: ['offer'],
    computed: {
        isCreditOffer: function () {
            return this.offer.type === 'line_of_credit' || this.offer.type === 'credit_card'
        },
    },
}
</script>
